interface FormSectionHeadingProps {
  title: string;
  description?: string;
}

/**
 * Cabeçalho de uma seção de formulário (título + subtítulo, sem ícone).
 * Compartilhado pelas duas cascas para que wizard e página tenham o mesmo visual.
 */
export function FormSectionHeading({ title, description }: FormSectionHeadingProps) {
  return (
    <div className="min-w-0">
      <h2 className="text-base font-medium leading-tight text-foreground">{title}</h2>
      {description && <p className="mt-0.5 text-sm text-muted-foreground">{description}</p>}
    </div>
  );
}
